(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-compose-runtime-runtime.js', './compose-multiplatform-core-compose-ui-ui.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-compose-runtime-runtime.js'), require('./compose-multiplatform-core-compose-ui-ui.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'.");
    }
    globalThis['compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'] = factory(typeof globalThis['compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-compose-runtime-runtime'], globalThis['compose-multiplatform-core-compose-ui-ui']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_compose_ui_ui) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var compositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.i1;
  var sourceInformationMarkerStart = kotlin_androidx_compose_runtime_runtime.$_$.j2;
  var traceEventStart = kotlin_androidx_compose_runtime_runtime.$_$.p2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var isTraceInProgress = kotlin_androidx_compose_runtime_runtime.$_$.s1;
  var sourceInformation = kotlin_androidx_compose_runtime_runtime.$_$.k2;
  var traceEventEnd = kotlin_androidx_compose_runtime_runtime.$_$.o2;
  var sourceInformationMarkerEnd = kotlin_androidx_compose_runtime_runtime.$_$.i2;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var findComposeDefaultViewModelStoreOwner = kotlin_org_jetbrains_compose_ui_ui.$_$.m7;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(LocalViewModelStoreOwner, 'LocalViewModelStoreOwner');
  //endregion
  var androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stable;
  function LocalViewModelStoreOwner$LocalViewModelStoreOwner$lambda() {
    return null;
  }
  function LocalViewModelStoreOwner() {
    LocalViewModelStoreOwner_instance = this;
    var tmp = this;
    tmp.yxk_1 = compositionLocalOf(VOID, LocalViewModelStoreOwner$LocalViewModelStoreOwner$lambda);
  }
  protoOf(LocalViewModelStoreOwner).zxk = function ($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, -584162872, 'C(<get-current>)35@1504L7:LocalViewModelStoreOwner.kt#3tja67');
    if (isTraceInProgress()) {
      traceEventStart(-584162872, $changed, -1, 'androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner.<get-current> (LocalViewModelStoreOwner.kt:35)');
    }
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = this.yxk_1;
    var $composer_1 = $composer_0;
    var tmp0_elvis_lhs = $composer_1.u31(this_0);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      $composer_0.m30(1260197608);
      sourceInformation($composer_0, '35@1515L32');
      var tmp1_group = findDefaultViewModelStoreOwner($composer_0, 0);
      $composer_0.n30();
      tmp = tmp1_group;
    } else {
      $composer_0.m30(1260196492);
      $composer_0.n30();
      tmp = tmp0_elvis_lhs;
    }
    var tmp0 = tmp;
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  };
  var LocalViewModelStoreOwner_instance;
  function LocalViewModelStoreOwner_getInstance() {
    if (LocalViewModelStoreOwner_instance == null)
      new LocalViewModelStoreOwner();
    return LocalViewModelStoreOwner_instance;
  }
  function androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter() {
    return androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stable;
  }
  function findDefaultViewModelStoreOwner($composer, $changed) {
    var $composer_0 = $composer;
    sourceInformationMarkerStart($composer_0, 1180308394, 'C(findDefaultViewModelStoreOwner)26@1005L39:LocalViewModelStoreOwner.nonAndroid.kt#3tja67');
    if (isTraceInProgress()) {
      traceEventStart(1180308394, $changed, -1, 'androidx.lifecycle.viewmodel.compose.findDefaultViewModelStoreOwner (LocalViewModelStoreOwner.nonAndroid.kt:26)');
    }
    var tmp0 = findComposeDefaultViewModelStoreOwner($composer_0, 0);
    if (isTraceInProgress()) {
      traceEventEnd();
    }
    sourceInformationMarkerEnd($composer_0);
    return tmp0;
  }
  //region block: init
  androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stable = 0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = androidx_lifecycle_viewmodel_compose_LocalViewModelStoreOwner$stableprop_getter;
  _.$_$.b = LocalViewModelStoreOwner_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-lifecycle-lifecycle-viewmodel-compose.js.map
